var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-form",
        { staticClass: "mx-auto", staticStyle: { "max-width": "600px" } },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        "offset-y": "",
                        "min-width": "auto"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        label: "Start Date",
                                        "prepend-icon": "mdi-calendar",
                                        readonly: "",
                                        clearable: "",
                                        "hide-details": ""
                                      },
                                      model: {
                                        value: _vm.form.startdate,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "startdate", $$v)
                                        },
                                        expression: "form.startdate"
                                      }
                                    },
                                    "v-text-field",
                                    attrs,
                                    false
                                  ),
                                  on
                                )
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.datepickers.start.open,
                        callback: function($$v) {
                          _vm.$set(_vm.datepickers.start, "open", $$v)
                        },
                        expression: "datepickers.start.open"
                      }
                    },
                    [
                      _c("v-date-picker", {
                        attrs: { "no-title": "" },
                        on: {
                          input: function($event) {
                            _vm.datepickers.start.open = false
                          }
                        },
                        model: {
                          value: _vm.form.startdate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "startdate", $$v)
                          },
                          expression: "form.startdate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        disabled: !_vm.form.startdate,
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        "offset-y": "",
                        "min-width": "auto"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        label: "End Date",
                                        "prepend-icon": "mdi-calendar",
                                        readonly: "",
                                        clearable: "",
                                        "hide-details": "",
                                        disabled: !_vm.form.startdate
                                      },
                                      model: {
                                        value: _vm.form.enddate,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "enddate", $$v)
                                        },
                                        expression: "form.enddate"
                                      }
                                    },
                                    "v-text-field",
                                    attrs,
                                    false
                                  ),
                                  on
                                )
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.datepickers.end.open,
                        callback: function($$v) {
                          _vm.$set(_vm.datepickers.end, "open", $$v)
                        },
                        expression: "datepickers.end.open"
                      }
                    },
                    [
                      _c("v-date-picker", {
                        attrs: { "no-title": "", min: _vm.form.startdate },
                        on: {
                          input: function($event) {
                            _vm.datepickers.end.open = false
                          }
                        },
                        model: {
                          value: _vm.form.enddate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "enddate", $$v)
                          },
                          expression: "form.enddate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Search",
                      "hide-details": "",
                      "prepend-icon": "mdi-magnify",
                      clearable: ""
                    },
                    on: {
                      keypress: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.search($event)
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "append",
                        fn: function() {
                          return [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0",
                                attrs: {
                                  depressed: "",
                                  tile: "",
                                  small: "",
                                  color: "primary"
                                },
                                on: { click: _vm.search }
                              },
                              [_vm._v("Search")]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.form.searchtext,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "searchtext", $$v)
                      },
                      expression: "form.searchtext"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-4" },
        [
          _c(
            "v-col",
            { staticClass: "d-flex align-center" },
            [
              _c(
                "v-chip",
                {
                  staticClass: "mr-2",
                  attrs: { small: "", color: "primary", "text-color": "white" }
                },
                [_vm._v(" Summary rows: " + _vm._s(_vm.summary.length) + " ")]
              ),
              _c(
                "v-chip",
                {
                  staticClass: "mr-2",
                  attrs: { small: "", color: "primary", "text-color": "white" }
                },
                [_vm._v(" Users: " + _vm._s(_vm.usersTotal) + " ")]
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "mr-2",
                  attrs: { small: "", outlined: "" },
                  on: { click: _vm.exportSummaryCsv }
                },
                [_vm._v("Export Summary CSV")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { small: "", outlined: "" },
                  on: { click: _vm.exportUsersCsv }
                },
                [_vm._v("Export Users CSV")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        staticClass: "elevation-1 mt-2",
        attrs: {
          dense: "",
          headers: _vm.headers,
          items: _vm.summarySorted,
          "items-per-page": 25,
          "item-key": "affiliate_id_referralcode_id",
          "show-expand": "",
          expanded: _vm.expanded,
          "footer-props": { itemsPerPageOptions: [-1, 15, 25, 50] },
          "header-props": { sortIcon: null }
        },
        on: {
          "update:expanded": function($event) {
            _vm.expanded = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c(
                  "v-toolbar",
                  { attrs: { flat: "" } },
                  [
                    _c("v-toolbar-title", [_vm._v("Referral Summary")]),
                    _c("v-spacer"),
                    _c("v-switch", {
                      staticClass: "mt-6",
                      attrs: { label: "Hide zero-signup codes", dense: "" },
                      model: {
                        value: _vm.hideZero,
                        callback: function($$v) {
                          _vm.hideZero = $$v
                        },
                        expression: "hideZero"
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function(ref) {
              var item = ref.item
              var expand = ref.expand
              var isExpanded = ref.isExpanded
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.affiliate_name))]),
                  _c("td", [_vm._v(_vm._s(item.description))]),
                  _c("td", { staticClass: "text-right" }, [
                    _vm._v(_vm._s(item.numusers))
                  ]),
                  _c(
                    "td",
                    { staticClass: "px-0", staticStyle: { width: "32px" } },
                    [
                      _c(
                        "v-icon",
                        {
                          on: {
                            click: function($event) {
                              return expand(!isExpanded)
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                isExpanded
                                  ? "mdi-chevron-up"
                                  : "mdi-chevron-down"
                              ) +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function(ref) {
              var headers = ref.headers
              var item = ref.item
              return [
                _c("tr", [
                  _c("td"),
                  _c(
                    "td",
                    { attrs: { colspan: headers.length - 2 } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "pa-3", attrs: { flat: "" } },
                        [
                          _c("div", { staticClass: "subtitle-2 mb-2" }, [
                            _vm._v(" Users for: "),
                            _c("strong", [_vm._v(_vm._s(item.affiliate_name))]),
                            _vm._v(" — "),
                            _c("em", [_vm._v(_vm._s(item.description))])
                          ]),
                          _c("v-data-table", {
                            staticClass: "elevation-0",
                            attrs: {
                              dense: "",
                              headers: _vm.userHeaders,
                              items: _vm.usersByReferral(item.referralcode_id),
                              "items-per-page": 10,
                              "footer-props": {
                                itemsPerPageOptions: [-1, 10, 25, 50]
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item.name",
                                  fn: function(ref) {
                                    var u = ref.item
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(u.firstname) +
                                          " " +
                                          _vm._s(u.lastname) +
                                          " "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("td")
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }